import React, { useState } from 'react';
import { Menu, Search, X } from 'lucide-react';
const NAV = ['Blagovne znamke', 'Vozila na zalogi', 'Storitve', 'O nas', 'Aktualno', 'Kontakt', 'Zaposlitev'];
export function Header() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full bg-aw-navy text-white" data-id="element-121" data-mp="19qe1q57zi4vx">
      <div className="mx-auto flex h-[68px] w-full max-w-[1360px] items-center gap-8 px-5 lg:px-10" data-id="element-122" data-mp="19r6xkb5en9za">
        <a href="#" className="font-heading text-2xl tracking-tight" data-id="element-123" data-mp="m12zejazk2fo">
          Auto<span className="font-bold" data-id="element-124" data-mp="i0iyd4nakeo9">Wallis</span>
        </a>

        <nav aria-label="Glavna navigacija" className="hidden flex-1 xl:block" data-id="element-125" data-mp="vqcrhz5txl3s">
          <ul className="flex items-center gap-7" data-id="element-126" data-mp="qzwbc7amjldq">
            {NAV.map(item => <li key={item} data-id="element-127" data-mp="qxteb3b20rzi">
                <a href="#" className="text-[12.5px] font-semibold uppercase tracking-[0.08em] text-white/90 transition-colors hover:text-aw-accent" data-id="element-128" data-mp="39tlzyy3gtit">
                  {item}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="ml-auto flex items-center gap-2" data-id="element-129" data-mp="bu8dq8kraz2i">
          <button type="button" aria-label="Iskanje" className="rounded-full p-2 text-white/90 transition-colors hover:bg-white/10 hover:text-white" data-id="element-130" data-mp="bsowofra0jzo">
            <Search className="h-5 w-5" data-id="element-131" data-mp="lmnw36zytpnx" />
          </button>
          <button type="button" aria-label={open ? 'Zapri meni' : 'Odpri meni'} aria-expanded={open} onClick={() => setOpen(v => !v)} className="rounded-full p-2 text-white transition-colors hover:bg-white/10 xl:hidden" data-id="element-132" data-mp="3k38gonfvfcfz">
            {open ? <X className="h-5 w-5" data-id="element-133" data-mp="1xdetokkmwnp" /> : <Menu className="h-5 w-5" data-id="element-134" data-mp="1uhexup5xxwm" />}
          </button>
        </div>
      </div>

      {open && <nav aria-label="Mobilna navigacija" className="border-t border-white/10 bg-aw-navy xl:hidden" data-id="element-135" data-mp="19c8bxh0to6sz">
          <ul className="mx-auto max-w-[1360px] px-5 py-3" data-id="element-136" data-mp="1ddlkhyvauo3l">
            {NAV.map(item => <li key={item} data-id="element-137" data-mp="3aehkqal0fr4f">
                <a href="#" className="block border-b border-white/10 py-3 text-sm font-semibold uppercase tracking-[0.08em] text-white/90 last:border-0" data-id="element-138" data-mp="35dtmb3ugc806">
                  {item}
                </a>
              </li>)}
          </ul>
        </nav>}
    </header>;
}